module.exports = __webpack_public_path__ + "static/pocketLogoCart-da6ea1e27dc051621e7e7cef9133b706.png";